import React, { useState } from 'react';
import ListOfSectionMenu from './ListOfSectionMenu';
import { toggleModal } from '../../reducers/modalReducer';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import KeyFeatureSeeMoreModal from '../modals/KeyFeatureSeeMoreModal';

const ModuleCardMenus = ({ module, onNavigateSection, setReportTab, type, seeMore, howItWorks, setIsWorkflowReport, menus, company }) => {
    const [selectedSeeMore, setSelectedSeeMore] = useState({});
    const dispatch = useDispatch();
    let sections = module?.['sections'] || module?.['module']?.['sections'] || [];

    const handleSeeMore = () => {
        setSelectedSeeMore(seeMore);
        dispatch(toggleModal({ open: 'seeMorePopupNew' }));
    };

    const handleHowItWorks = () => {
        dispatch(toggleModal({ open: 'howItWorksPopupNew', howItWorksData: howItWorks }));
    };

    const getHelpLink = (module) => {
        const type = module?.['type'];
        if (!type || typeof type === 'object') {
            return ''
        }
        const helpLinks = {
            'kpi-report': 'https://intercom.help/diligentsia-limited/en/articles/8557593-key-performance-indicator-kpi-reporting',
            'repository': 'https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository',
            'unaudited-certification': 'https://intercom.help/diligentsia-limited/en/collections/6775868-your-certification',
            'warranty-disclosure': 'https://intercom.help/diligentsia-limited/en/articles/8557715-expansion-pack-warranty-disclosure-module',
            'directors-questionnaire': 'https://intercom.help/diligentsia-limited/en/articles/8557468-directors-questionnaire-module',
            'software-development': 'https://intercom.help/diligentsia-limited/en/articles/8557691-expansion-pack-software-development',
            'esg': 'https://intercom.help/diligentsia-limited/en/articles/8557477-expansion-pack-environmental-social-governmental-esg',
        };

        // handle prefix-based types
        if (type.includes('two-minute-test-')) {
            return 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard';
        }

        if (type.includes('business-audit-')) {
            return 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit';
        }

        return helpLinks[type] || '';
    };


    return (
        <>
            <div className="ds-module-menu">
                <div className="ds-module-card__menu">•••</div>
                <div className="ds-module-menu__dropdown">
                    <div className="ds-module-menu__section ds-submenu">
                        {
                            sections.length > 0 && (menus?.includes('listOfSections') || module?.['menus']?.includes('listOfSections')) && <ListOfSectionMenu module={module} sections={sections} onNavigateSection={onNavigateSection} />
                        }

                        {seeMore && (menus?.includes('seeMore') || module?.['menus']?.includes('seeMore')) ? <button type="button" onClick={handleSeeMore} className="ds-module-menu__item df aic">
                            <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/whatisit.png')} alt="what-is-it" />
                            What is it
                        </button> : null}
                        {howItWorks && (menus?.includes('howItWorks') || module?.['menus']?.includes('howItWorks')) ? <button type="button" onClick={handleHowItWorks} className="ds-module-menu__item df aic">
                            <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/howitworks.png')} alt="what-is-it" />How it works</button> : null}
                        {getHelpLink(module) !== '' ? <button type="button" onClick={() => window.open(getHelpLink(module), '_blank', 'noopener,noreferrer')} className="ds-module-menu__item df aic">
                            <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/help.png')} alt="what-is-it" />
                            Help
                        </button> : null}

                    </div>
                    {
                        ((seeMore || howItWorks || getHelpLink(module) !== '') && (menus?.includes('report'))) ? <div className="ds-module-menu__divider" /> : null
                    }
                    <div className="ds-module-menu__section">
                        {(menus?.includes('report') || module?.['menus']?.includes('report')) && <Link
                            disabled={(['warranty-disclosure', 'directors-questionnaire'].includes(module['type'])) && !company['expensions'][module['id']]}
                            to={(module?.['stats']?.completionPercent > 0 && type != 'investor-lead') && `#${type}-report`}
                            onClick={() => {
                                if ((['warranty-disclosure', 'directors-questionnaire'].includes(module['type'])) && !company['expensions'][module['id']]) {
                                    return;
                                }
                                module?.['stats']?.completionPercent > 0 && setReportTab(type);
                            }}
                            className={`ds-module-menu__item df aic ${module?.['stats']?.completionPercent == 0 ? 'ds-is-disabled' : ''} ${((['warranty-disclosure', 'directors-questionnaire'].includes(module['type'])) && !company['expensions'][module['id']]) ? 'ds-is-disabled' : ''}`}
                        >
                            <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/R.png')} alt="what-is-it" />
                            Report
                        </Link>}
                        {(menus?.includes('workflow') || module?.['menus']?.includes('workflow')) && <Link
                            to={module?.['stats']?.completionPercent > 0 && `#${module['type']}`}
                            onClick={(e) => { module?.['stats']?.completionPercent > 0 && localStorage.setItem('isWorkflowOpen', true); setIsWorkflowReport(true); setTab(`${module['type']}-report`) }}
                            className={`ds-module-menu__item df aic ${module?.['stats']?.completionPercent == 0 ? 'ds-is-disabled' : ''}`}
                        >
                            <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/WF.png')} alt="what-is-it" />
                            Workflow report
                        </Link>}
                    </div>
                </div>
            </div>
            {
                Object.keys(selectedSeeMore).length ? <KeyFeatureSeeMoreModal selectedSeeMore={selectedSeeMore} /> : null
            }
        </>
    )
};

export default ModuleCardMenus;
